import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { H3 } from '../../../components/UI'
import I18n from 'i18n-js'
import { makeStyles } from '@material-ui/core/styles'
import SocialNetworks from '../../../components/Main/SocialNetworks'
import Grid from '@material-ui/core/Grid'
import jMoment from 'moment-jalaali'
import styles from './ReserveInfo.module.css'
import BlankProfile from '../../../assets/images/blank-profile.png'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({

	avatar: {
		width: 62,
		height: 62,
		borderRadius: 10,
		'body[dir=rtl] &': {
			marginLeft: 20

		},
		'body[dir=ltr] &': {
			marginRight: 20

		}
	},

	info: {
		[theme.breakpoints.up('md')]: {
			'body[dir=rtl] &': {
				borderRight: '1px solid #E6E8F2',
				paddingRight: '10px'
			},
			'body[dir=ltr] &': {
				borderLeft: '1px solid #E6E8F2',
				paddingLeft: '10px'
			}
		}
	},

	infoService: {
		[theme.breakpoints.down('sm')]: {
			marginTop: '24px'
		},
		marginBottom: '12px',
		// marginTop: '12px',
		'& span': {
			fontSize: '14px',
			color: '#474A57',
			marginBottom: '8px'
		}
	},
	infoTime: {
		marginBottom: '12px',
		marginTop: '12px',
		'& span': {
			fontSize: '14px',
			color: '#474A57',
			marginBottom: '8px'
		},
		'& strong': {
			direction: 'rtl',
			textAlign: 'right'
		}
	}
}))

const ReserveInfo = (props) => {
	const classes = useStyles()
	const {
		timezone,
		language
	} = useSelector(state => state.SettingsReducer)

	const { reserve } = props

	const getDate = () => {
		let finalDate = jMoment(`${reserve.date} ${reserve.start_at}:00`, 'YYYY-MM-DD H:m:s').format('D MMMM YYYY')
		if (language === 'fa') {
			jMoment.loadPersian({ dialect: 'persian-modern' })
			finalDate = jMoment(`${reserve.date} ${reserve.start_at}:00`, 'YYYY-MM-DD H:m:s').format('jD jMMMM jYYYY')
		}

		return `${finalDate}`
	}
	const getTime = () => {
		if (language === 'fa')
			jMoment.loadPersian({ dialect: 'persian-modern' })

		const finalStartAt = jMoment(`${reserve.date} ${reserve.start_at}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')
		const finalEndAt = jMoment(`${reserve.date} ${reserve.end_at}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')

		const kind = jMoment(`${reserve.date} ${reserve.start_at}:00`, 'YYYY-MM-DD H:i:s').format('HH') >= 12
			? I18n.t('settings.pm')
			: I18n.t('settings.am')
		const timezoneT = I18n.t('settings.time')

		return ` ${finalStartAt} - ${finalEndAt} ${kind} ( ${timezoneT} ${timezone} )`
	}

	console.log('rserce', reserve)

	return (
		<Grid container className={styles.Card} justify={'center'}>
			<Grid item xs={12} md={5}>
				<Grid container>
					<Grid item xs={11} md={12}>
						<div className={styles.consultantProfileContainer}>
							<div>
								<Avatar
									className={classes.avatar}
									variant="rounded"
									alt={`${reserve.consultant.first_name} ${reserve.consultant.last_name}`}
									src={reserve.consultant.profile_url ? reserve.consultant.profile_url : BlankProfile}
								/>
							</div>
							<div>
								<div>
									<H3 style={{ fontWeight: 'bold' }}>{reserve.consultant.first_name} {reserve.consultant.last_name}</H3>
									<SocialNetworks socialNetworks={reserve.consultant.social_networks}/>
								</div>
							</div>
						</div>
						<div className={styles.description}>
							<p style={{fontSize:14}}>{reserve.consultant.reserve_description}</p>
						</div>
					</Grid>


				</Grid>
			</Grid>

			<Grid item xs={12} md={6}>
				<div className={classes.info}>
					<div className={classes.infoService}>
						<span>{I18n.t('consultant.profile.service')}</span><br/>
						<strong>{reserve.service.title}</strong>
					</div>

					<div className={classes.infoTime}>
						<span>{I18n.t('consultant.profile.dateOfConsultation')}</span><br/>
						<strong>{getDate()}</strong>
					</div>
					<div className={classes.infoTime}>
						<span>{I18n.t('consultant.profile.consultationHours')}</span><br/>
						<strong>{getTime()}</strong>
					</div>
				</div>
			</Grid>
		</Grid>

	)
}

export default ReserveInfo
